import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Panel from "@ui/panel/Panel";
import { X } from "lucide-react";
import styled from "styled-components";
import { Settings } from "../forms/Settings";

const Header = styled.header`
	display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; flex: 0 0 auto;
	padding: 20px 24px 16px; border-bottom: 1px solid #edf0f5; background: #fff;
	font: 13px/1.5 "Euclid Circular B", sans-serif; color: #344054;
	.identity { min-width: 0; }
	.eyebrow { margin-bottom: 5px; color: #667085; font-size: 11px; }
	h2 { margin: 0; color: #182230; font-size: 21px; font-weight: 600; line-height: 1.3; overflow-wrap: anywhere; }
	button { display: grid; place-items: center; flex: 0 0 32px; width: 32px; height: 32px; padding: 0; border: 0; border-radius: 7px; background: transparent; color: #667085; cursor: pointer; }
	button:hover { background: #f5f7fa; }
`;

const Body = styled.div`
	flex: 1 1 auto; min-height: 0; overflow: auto; padding: 24px; background: #f5f7fa;
	/* The popup supplies the background and spacing around the form's cards. */
	> div { padding: 0 !important; border-radius: 0 !important; background-color: transparent !important; max-width: none !important; }
	@media (max-width: 600px) { padding: 16px; }
`;

export const ProjectSettingsPopup = ({ projectId, projectName, onClose }: { projectId: number; projectName: string; onClose: () => void }) => { useLocale(); return ((
	<Panel decorator="absolute" growContent disableScroll onClose={onClose}
		sx={{ padding: "0", width: "860px", maxWidth: "94vw", height: "88dvh", maxHeight: "88dvh", borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff" }}>
		<Header>
			<div className="identity"><div className="eyebrow">{msg("projectSettings")}</div><h2>{projectName}</h2></div>
			<button type="button" aria-label={msg("closeProjectSettings")} onClick={onClose}><X size={18} /></button>
		</Header>
		<Body><Settings key={projectId} size="small" target_id={projectId} target_type="project" type="project_settings" appearance="modern" /></Body>
	</Panel>
)); };
